import ListingsRoutingResolver from './ListingRoutingResolver';

class ActivityListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "crm-activity"
    }
}

export default ActivityListingResolver
